/**
 * Clipboard write used by extension install UI (HTTPS → chrome:// / edge://).
 */
export function writeTextToClipboard(text) {
    return navigator.clipboard.writeText(text);
}
